import { getTotalPrice } from '../../common/utils/price';
import { ProductCardLayoutType } from '../../common/models/product';
import { MEAL } from '../../products';
import { isPrimaryFlow } from '../../common/utils/primaryFlow';
import { getSmallMealPrice } from './smallMealUtil';
import { getLayoutType } from './units';
export const getPrice = form => state => {
  const isSmallCardEnabled = getLayoutType(form, state) === ProductCardLayoutType.Small;
  return isSmallCardEnabled && isPrimaryFlow() ? getSmallMealPrice(form, MEAL.name)(state) : getTotalPrice(form, `${MEAL.name}.dropdowns`)(state);
};
//# sourceMappingURL=price.js.map